/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class JrQuestionGenerator {
  constructor() {
    this.negativeMod = 0;

    this.getNewNumberSet();
  }

  getNewNumberSet() {
    let question = [];
    const num1 = { type: null, value: 0 };
    const num2 = { type: null, value: 0 };

    num1.value = Phaser.Math.Between(1, 10);
    num2.value = Phaser.Math.Between(1, 10);

    question = [num1, num2];
    return question;
  }
}